import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'

import { PATHS } from 'Config/Routing/paths'
import ClientSettings from '../../Containers/ClientSettings'
import CouponsType from '../../Containers/ClientSettings/pages/CouponsType'
import SelectStore from '../../Containers/ClientSettings/pages/SelectStore'
import CouponsTable from '../../Containers/ClientSettings/pages/CouponsTable'
import CouponForm from '../../Containers/ClientSettings/pages/CouponForm'
import CSVUpload from '../../Containers/ClientSettings/pages/CSVUpload'
import IntegrationRouter from './IntegrationRouter'
import UserManagementRouter from './UserManagement'

const ClientSettingsRouter = props => {
  const {
    match: { url },
    userRole,
  } = props

  const baseClientSettingsPath =
    PATHS.main.dashboard + PATHS.dashboard.clientSettings

  return (
    <Switch>
      <Route
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.clientSettings +
          PATHS.clientSettings.coupons +
          PATHS.clientSettings.createCoupon +
          PATHS.clientSettings.stores +
          PATHS.store.storeView
        }
      >
        <CouponForm url={url} />
      </Route>
      <Route
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.clientSettings +
          PATHS.clientSettings.coupons +
          PATHS.clientSettings.createCoupon +
          PATHS.clientSettings.stores
        }
      >
        <SelectStore url={url} />
      </Route>
      <Route
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.clientSettings +
          PATHS.clientSettings.coupons +
          PATHS.clientSettings.createCoupon +
          PATHS.clientSettings.csvUpload
        }
      >
        <CSVUpload url={url} />
      </Route>
      <Route
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.clientSettings +
          PATHS.clientSettings.coupons +
          PATHS.clientSettings.createCoupon
        }
      >
        <CouponsType url={url} />
      </Route>
      <Route
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.clientSettings +
          PATHS.clientSettings.coupons
        }
      >
        <CouponsTable url={url} />
      </Route>
      <Route
        path={`${baseClientSettingsPath}${PATHS.clientSettings.userManagement}`}
      >
        <UserManagementRouter />
      </Route>

      <Route
        path={`${baseClientSettingsPath}${PATHS.clientSettings.integration}`}
      >
        <IntegrationRouter />
      </Route>

      <Route exact path={PATHS.main.dashboard + PATHS.dashboard.clientSettings}>
        <ClientSettings url={url} userRole={userRole} />
      </Route>
    </Switch>
  )
}

export default withRouter(ClientSettingsRouter)
